<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <DocuformDeleteConfirmation :show="true"
                                  :type="dialogProps.type"
                                  @close="handleSubmit(false)"
                                  @delete="handleSubmit(true)"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import DocuformDeleteConfirmation from "../components/DocuformDeleteConfirmation";

export default {
  name: "DocuformDeleteConfirmationDialog",
  components: {FullscreenFrontageDialog, DocuformDeleteConfirmation},
  methods: {
    handleSubmit(confirm) {
      this.$refs.frontageDialog.handleSubmit(confirm);
    }
  }
}
</script>
